import { useState } from 'react'
import axios from 'axios'
import { v4 as uuidv4 } from 'uuid'

import Ingredient from './components/ingredient'
import ScrollTop from './components/scrollTop'
import Sort from './components/sort'
import SearchForm from './components/searchForm'
import Spinner from './components/spinner'
import NotFound from './components/notFound'
import Modal from './components/modal'

import styles from './App.module.css'

export default function App() {
  const [ingredientsList, setIngredientsList] = useState([])
  const [notFoundIngredients, setNotFoundIngredients] = useState([])
  const [searchQuery, setSearchQuery] = useState("")
  const [loadingState, setLoadingState] = useState(false)
  const [error, setError] = useState(null)
  const [showModal, setShowModal] = useState(false)

  const fetchData = async (query) => {
    let queryList = query.replace(/\s*\([^)]*\)\s*/g, " ").split(",").map(query => query.toLowerCase().trim()).filter(query => query !== "")
    if (queryList.includes("1") && queryList.includes("2-hexanediol")) {
      queryList = queryList.filter(query => query !== "1" && query !== "2-hexanediol")
      queryList.push("1, 2-hexanediol")
    }

    // let url = 'http://localhost:3500/?'
    let url = process.env.REACT_APP_API_ENDPOINT
    queryList.forEach((query,idx) => {
      url += (idx === 0 ? '' : '&') + `name${idx + 1}=${encodeURIComponent(query.trim())}`
    })

    try{
      const response = await axios.get(url)

      if(response.status !== 200) {
        throw new Error(`HTTP error, status: ${response.status}`)
      } else {
        console.log(response)
        setIngredientsList(response.data.found)
        setNotFoundIngredients(response.data.notFound)
      }
    } catch(e) {
      setError(e.message)
      setShowModal(true)
    }

    setLoadingState(false)
  }

  const toggleShowModal = () => {
    setShowModal(!showModal)
  }

  const handleSearchQuery = () => {
    //reset the list to empty (no ingredients should be displaying)
    setIngredientsList([])
    setNotFoundIngredients([])
    //send query to db, show loading spinner waiting for response
    setLoadingState(true)
    fetchData(searchQuery.trim())
  }

  return (
    <div className={styles.container}>
      <main className={styles.main}>
        <h1 className={styles.title}>
          clarity
        </h1>
        <SearchForm
          searchQuery={searchQuery}
          searchQueryInputSetter={setSearchQuery}
          sendSearchQueryHandler={searchQuery.length ? handleSearchQuery : null}
          buttonActivated={searchQuery.length ? true : false}
        />
        <Modal
          show={showModal}
          message={error}
          showModalToggler={toggleShowModal}
        />
        {loadingState ? <Spinner/> : null}
        { notFoundIngredients.length ? <NotFound list={notFoundIngredients}/>: null}
        {ingredientsList.length ? <Sort list={ingredientsList} listSetter={setIngredientsList}/> : null}
        {ingredientsList.length ? ingredientsList.map((ingredient) => <Ingredient
          key={ingredient._id + ingredient.moreInfoUrl + uuidv4()}
          name={ingredient.name}
          moreInfoUrl={ingredient.moreInfoUrl}
          rating={ingredient.rating}
          description={ingredient.description}
          category={ingredient.category}
          seeAlso={ingredient.seeAlso}
        />) : null}
      </main>
      <ScrollTop/>
      <footer className={styles.footer}>
        <a
          href="https://gmitchellgomez.com"
          target="_blank"
          rel="noopener noreferrer"
        >
          Gabriel Gomez © 2021
        </a>
      </footer>
    </div>
  )
}
